export { routerBaseName as ROUTER_BASE_NAME } from '@/../package.json'

/** 静态资源 CDN 域名 */
export const CDN_DOMAIN = 'vol-v6.bczcdn.com'

/** 百词斩 Logo */
export const BCZ_LOGO_URL = `https://${CDN_DOMAIN}/r/w9w52ktt4v2e79frmad5m7dyefegutmf.png`

/**
 * 百词斩 App 下载链接（应用宝）
 */
export const BCZ_DOWNLOAD_LINK = `https://a.app.qq.com/o/simple.jsp?pkgname=com.jiongji.andriod.card`

/** XHR 请求重试延时（单位：毫秒） */
export const XHR_RETRY_DELAY = 3000

/** 升级提示文案 */
export const UPGRADE_TIPS = '客户端版本过低，请先更新'

/** 用户默认头像 */
export const USER_DEFAULT_AVATAR = `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTI4IiBoZWlnaHQ9IjEyOCIgdmlld0JveD0iMCAwIDEyOCAxMjgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIxMjgiIGhlaWdodD0iMTI4IiBmaWxsPSIjRTdFREZDIi8+CjxlbGxpcHNlIGN4PSI2NCIgY3k9IjQ0IiByeD0iMjIiIHJ5PSIyMiIgZmlsbD0iIzEyNEVFNiIgZmlsbC1vcGFjaXR5PSIwLjE2Ii8+CjxwYXRoIGQ9Ik0yMy41IDExMy41QzIzLjUgOTkuOTc1NCAyMy41IDkzLjIxMyAyNS45NTQ1IDg3Ljk3MjRDMjguNTM0NCA4Mi40NjM5IDMyLjk2MzkgNzguMDM0NCAzOC40NzI0IDc1LjQ1NDVDNDMuNzEzIDczIDUwLjQ3NTQgNzMgNjQgNzNDNzcuNTI0NiA3MyA4NC4yODcgNzMgODkuNTI3NiA3NS40NTQ1Qzk1LjAzNjEgNzguMDM0NCA5OS40NjU2IDgyLjQ2MzkgMTAyLjA0NiA4Ny45NzI0QzEwNC41IDkzLjIxMyAxMDQuNSA5OS45NzU0IDEwNC41IDExMy41VjEyOEgyMy41VjExMy41WiIgZmlsbD0iIzEyNEVFNiIgZmlsbC1vcGFjaXR5PSIwLjE2Ii8+Cjwvc3ZnPgo=`
